<template>
    <div style="width:100%;">
       <center> <el-empty :description="$t('search.no_results')" style="margin-top:250px;" /></center>
    </div>
</template>